export enum TranslationsZh {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = '周一',
  TUE = '周二',
  WED = '周三',
  THU = '周四',
  FRI = '周五',
  SAT = '周六',
  SUN = '周日',
  STREET_ADDRESS1 = '地址1',
  STREET_ADDRESS2 = '地址2',
  CITY = '城市',
  STATE = '州',
  ZIP_CODE = '邮编',
  COUNTRY = '国家',
  OK = '确定',
  CANCEL = '取消',
  CONFIRMATION = '确认',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = '确定要取消吗？',
  STEP = '步骤',
  OF = '的',
  PREVIOUS = '上一步',
  NEXT = '下一步',
  SUBMIT = '提交',
  CLOSE = '关闭',
  ENLARGED_ATTACHMENT = '放大附件',
  NO_INFO = '没有信息',
  BEDROOMS = '卧室',
  BATHROOMS = '浴室',
  HOME = '家',
  PROGRESS = '进度',
  START_DATE = '开始日期',
  END_DATE = '结束日期',
  UNKNOWN = '未知',
  VIEW_ALL = '查看所有',
  FEET = '英尺',
  SUCCESS = '成功！',
  FINISH = '完成',
  SOMETHING_WENT_WRONG = 'Oops! 出错了！',
  EMAIL = '邮箱',
  UPLOAD_FILE = '上传文件',
  BACK = '返回',
  TENANT_SIGN_IN = '租户登录',
  NO_RENTAL_HISTORY_ERROR = '请至少输入一个之前的租赁信息。',
  REMOVE = '删除',
  APPLICANT_INFORMATION = '申请人信息',
  POTENTIAL_UNITS = '潜在单位',
  UNITS_OF_INTEREST = '感兴趣的单位',
  ALL_UNITS = '所有单位',
  OPEN_TO_ALL_UNITS = '对所有单位开放',
  RENTAL_HISTORY = '租赁历史',
  WORK_HISTORY = '工作历史和收入验证',
  TERM_AND_CONDITIONS = '条款和条件',
  CONFIRM_YOUR_IDENTITY = '确认你的身份',
  PETS_AND_CARS = '宠物和汽车',
  QUESTIONS = '问题',
  RENTAL_APPLICATION = '租赁申请',
  SUBMIT_A_RENTAL_APPLICATION = '提交租赁申请',
  MAGICDOOR_TERMS = 'MagicDoor 条款和条件',
  TRANS_UNION_TERMS = 'TransUnion 条款和条件',
  ADD_RENTAL_HISTORY = '添加租赁历史',
  REASON_FOR_LEAVING = '离开原因',
  LANDLORD_NAME = '房东姓名',
  LANDLORD_PHONE = '房东电话',
  RENT = '租金',
  MOVE_IN_DATE = '搬入日期',
  MOVE_OUT_DATE = '搬出日期',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = '我已阅读并同意服务条款',
  ADD_EMPLOYMENT = '添加就业',
  EMPLOYMENT_HISTORY = '就业历史',
  I_AM_EMPLOYED = '我目前有工作',
  ANNUAL_INCOME = '年收入',
  NAME = '姓名',
  PHONE = '电话',
  POSITION = '职位',
  JOB_TITLE = '职位',
  SALARY = '薪水',
  START_SCREENING = '开始筛选',
  PAYMENT_DETAILS = '支付详情',
  SUBMIT_ANSWERS = '提交答案',
  PAYMENT_PROCESSING = '支付处理 ...',
  PAYMENT_PROCESSING_BLURB = '您的交易正在处理。这可能需要几分钟。请耐心等待，不要关闭屏幕',
  DONE = '完成',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = '您的租赁申请已成功提交！',
  RENTAL_APPLICATION_NOTIFICATION = '申请状态将通过电子邮件通知。请检查您的电子邮件。',
  CONNECTING_TO_TRANS_UNION = '连接到TransUnion准备问卷并启动身份验证 ...',
  CONNECTING_TO_TRANS_UNION_BLURB = '请耐心等待，不要离开此页面 - 我们正在安全地获取您的问卷并设置身份验证。',
  CONTACT_CUSTOMER_SUPPORT = '为了完成您的筛选过程，请联系我们的客户支持',
  CONTACT_CUSTOMER_SUPPORT_BLURB = '在通话期间，请保持在此屏幕上以获取实时更新。一旦您的通话结束，请留在页面上进行下一步。',
  UNABLE_TO_VERIFY_IDENTITY = '我们无法在线验证您的身份。',
  RENTER_SCREENING_ID = '租户筛选ID= {renterID}',
  PAGE_NOT_FOUND = '页面未找到',
  PAGE_NOT_FOUND_BLURB_1 = '看起来您找到了通向伟大虚无的门，很抱歉。',
  PAGE_NOT_FOUND_BLURB_2 = '请访问我们的主页以到达您需要的地方。',
  COMPANY_NOT_FOUND = '看起来您正在寻找的页面不存在。请检查URL或联系您的物业经理以获取帮助。',
  FIRST_NAME = '名字',
  LAST_NAME = '姓氏',
  SSN = 'SSN',
  DATE_OF_BIRTH = '出生日期',
  VIEW_IN_FULL_SCREEN = '在新标签页中打开',
  WELCOME = '欢迎',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = '您必须接受此许可协议',
  PAY = '支付',
  RENTAL_APPLICATION_FEE_BLURB = '您需要支付 {amount} 的不可退还费用来提交您的申请，这将用于筛选成本。',
  TEXT_ONLY = '仅文本',
  LEASING = '租赁',
  CONFIRM = '确认',
  END_DATE_IS_INVALID = '结束日期无效',
  FIRST_NAME_IS_INVALID = '名字无效',
  LAST_NAME_IS_INVALID = '姓氏无效',
  EMAIL_IS_INVALID = '邮箱无效',
  PHONE_NUMBER_IS_INVALID = '电话号码无效',
  DATE_OF_BIRTH_IS_INVALID = '出生日期无效',
  DATE_OF_BIRTH_IS_GREATER = '年龄不能大于125岁',
  DATE_OF_BIRTH_IS_LESSER = '年龄不能小于18岁',
  ANNUAL_INCOME_IS_INVALID = '年收入无效',
  SSN_IS_INVALID = 'SSN无效',
  EMPLOYER_NAME_IS_INVALID = '雇主姓名无效',
  SALARY_IS_INVALID = '薪水无效',
  POSITION_TITLE_IS_INVALID = '职位/标题无效',
  START_DATE_IS_INVALID = '开始日期无效',
  END_DATE_IS_INVALID_EARLIER = '结束日期不能早于开始日期',
  ADDRESS_IS_INVALID = '地址无效',
  STREET_ADDRESS_1_IS_INVALID = '街道地址1无效',
  STREET_ADDRESS_2_IS_INVALID = '街道地址2无效',
  REASON_FOR_LEAVING_IS_INVALID = '离开原因不能超过500个字符',
  CITY_IS_INVALID = '城市无效',
  STATE_IS_INVALID = '州无效',
  ZIP_CODE_IS_REQUIRED = '邮编必填',
  ZIP_CODE_IS_INVALID = '美国邮编必须由5位数字组成',
  COUNTRY_IS_INVALID = '国家无效',
  LANDLORD_NAME_IS_INVALID = '房东姓名无效',
  LANDLORD_PHONE_NUMBER_IS_INVALID = '房东电话号码无效',
  RENT_IS_INVALID = '租金无效',
  MOVE_IN_DATE_IS_INVALID = '搬入日期无效',
  MOVE_OUT_DATE_IS_INVALID = '搬出日期无效',
  MOVE_IN_DATE_IS_LATER = '搬入日期不能晚于搬出日期',
  MOVE_OUT_DATE_IS_EARLIER = '搬出日期不能早于搬入日期',
  JOB_TITLE_IS_INVALID = '职位/标题无效',
  FILE_IS_REQUIRED = '文件必填',
  COMPANY_NAME = '公司名称',
  FOLLOW_US = '关注我们',
  PROPERTIES = '物业',
  CONTACT_US = '联系我们',
  LET_US_GUIDE_YOUR_HOME = '让我们引导你的家',
  BANNER_TITLE = '发现一个你喜欢的家',
  SEARCH = '搜索',
  PROPERTY_FOR_YOU_TITLE = '为你准备的物业',
  PROPERTY_FOR_YOU_SUBTITLE = '搜索并保存几个你喜欢的房子，我们会为你推荐。',
  PINNED = '固定',
  PRICE = '价格',
  MIN = '最小',
  MAX = '最大',
  NO_MIN = '没有最小',
  NO_MAX = '没有最大',
  HOME_TYPE = '房屋类型',
  BEDS_AND_BATHS = '卧室和浴室',
  ANY = '任何',
  SINGLE_FAMILY = '单户家庭',
  MULTI_FAMILY = '多户家庭',
  COMMERCIAL = '商业',
  CONDO = '公寓',
  TOWN_HOUSE = '联排别墅',
  RESET = '重置',
  CONTACT_MANAGER = '联系经理',
  PET = '宠物',
  PETS = '宠物',
  AC = '空调',
  PARKING = '停车位',
  UTILITIES_INCLUDED = '包含水电费',
  INTERIOR_AMENITIES = '内部设施',
  OUTDOOR_AMENITIES = '外部设施',
  COMMUNITY_AMENITIES = '社区设施',
  OUTDOOR = '户外',
  LISTED = '已列出',
  MONTH = '月',
  SQFT = '平方英尺',
  OVERVIEW = '概览',
  HOME_HIGHLIGHTS = '家亮点',
  FACTS_AND_FEATURES = '事实和功能',
  LOCAL_INFORMATION = '本地信息',
  SELECT_PRICE = '选择价格',
  SELECT_HOME_TYPE = '选择房屋类型',
  SELECT_MOVE_IN_DATE = '选择搬入日期',
  SLIDE_UP_TO_LOAD_MORE = '上滑加载更多',
  APPLY = '应用',
  PROPERTY_DETAIL = '物业详情',
  ZERO_RESULTS_DESC = '没有找到给定地址的结果。请检查地址并重试。',
  MAP_ERROR_DESC = '加载地图时发生错误。请稍后再试。',
  SEARCH_FOR_YOUR_DREAM_HOME = '搜索你的梦想之家',
  ALL_RIGHTS_RESERVED = '所有权利保留',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = '我们目前没有可用的单位，但您总是欢迎提交租赁申请给我们',
  PRIVACY_POLICY = '隐私政策',
  ACCEPT_TERMS_AND_CONDITIONS_PROCEED = '请接受条款和条件以继续。',
  TERMS_OF_SERVICE = '服务条款',
  EQUAL_HOUSING_OPPORTUNITY = '平等住房机会',
  FILTER = '过滤器',
  FILTERS = '过滤器',
  SIGN_HERE = '在这里签名！',
  ALLOWED = '允许',
  MONTHLY_PET_FEES = '每月宠物费用',
  NO_LIMIT = '没有限制',
  PET_DEPOSIT = '宠物押金',
  SMALL_WEIGHT = '小（小于22.0462磅）',
  MEDIUM_WEIGHT = '中（22.0462 - 55.1156磅）',
  LARGE_WEIGHT = '大（55.1156 - 110.2311磅）',
  CATS = '猫',
  DOGS = '狗',
  OTHER = '其他',
  FISH = '鱼',
  BIRDS = '鸟',
  REPTILES = '爬行动物',
  OTHERS = '其他',
  ALL_ALLOWED = '所有允许',
  DESIRED_MOVE_IN_DATE_IS_INVALID = '期望搬入日期无效',
  DESIRED_MOVE_IN_DATE = '期望搬入日期',
  CURRENT_UNIT_IS_UNLISTED = '您当前申请的单位已下架，将在3秒后返回主页。',
  PLEASE_ANSWER_THIS_QUESTION = '请回答这个问题',
  COMMENT_CANNOT_EXCEED = '评论不能超过500个字符',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = '您可以添加评论给经理',
  COMMENT = '评论',
  PET_NAME_IS_INVALID = '宠物名称无效',
  BREED_IS_INVALID = '品种无效',
  PET_WEIGHT_IS_INVALID = '宠物重量无效',
  AGE_IS_INVALID = '年龄无效',
  GENDER_IS_INVALID = '性别无效',
  SPAY_NEUTER_STATUS_IS_INVALID = '绝育状态无效',
  SERVICE_ANIMAL_STATUS_IS_INVALID = '服务动物状态无效',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = '情感支持动物状态无效',
  CAR_MAKE_IS_INVALID = '车辆制造商无效',
  MODEL_IS_INVALID = '型号无效',
  YEAR_IS_INVALID = '年份无效',
  LICENSE_PLATE_IS_INVALID = '车牌无效',
  STATE_REGISTRATION_IS_INVALID = '州注册无效',
  CAR_COLOR_IS_INVALID = '车辆颜色无效',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = '您已成功签署租赁协议。请留意我们未来的消息。',
  BREED = '品种',
  WEIGHT = '重量',
  AGE = '年龄',
  GENDER = '性别',
  CAR = '车',
  CAR_MAKE = '车辆制造商',
  MODEL = '型号',
  YEAR = '年份',
  LICENSE_PLATE = '车牌',
  STATE_REGISTRATION = '州注册',
  COLOR = '颜色',
  SPAYED_OR_NEUTERED = '我的宠物已绝育/绝育',
  SERVICE_ANIMAL = '我的宠物是服务动物',
  EMOTIONAL_SUPPORT_ANIMAL = '我的宠物是情感支持动物',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = '操作失败，请稍后再试',
  REMOVE_SELECTED = '删除选中',
  PURCHASE_RENTAL_INSURANCE = '购买租赁保险',
  LINK_EXPIRED = '链接已过期',
  THE_LINK_HAS_EXPIRED_BUT_WE_VE_SENT_YOU_ANOTHER_ONE_TO_YOUR_REGISTERED_EMAIL_ADDRESS = '链接已过期，但我们已发送另一个到您的注册邮箱。',
  DO_YOU_HAVE_A_PET = '您有宠物吗？',
  ADD_NEW_PET = '添加新宠物',
  DO_YOU_HAVE_A_CAR = '您有车吗？',
  ADD_NEW_CAR = '添加新车',
  NO_UNITS_LISTED = '目前，没有单位列出',
  OR_LESS = '或更少',
  OR_MORE = '或更多',
  ANY_PRICE = '任何价格',
  NO_MORE_RESULTS = '没有更多结果',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = `通过提交此表格，您同意{companyName}在提供的号码上向您发送账户通知和公司直接通信消息，包括通过自动拨号器发送的消息。消息频率可能会有所不同。同意不是购买的条件。可能会收取消息和数据费用。随时回复STOP取消订阅。回复HELP获取帮助。 `,
  SEARCH_UNITS = '搜索单位...',
  OOPS = '哎呀！',
  APPLY_NOW = '立即申请',
  SUMMARY = '摘要',
  APPLICATION_EDIT_WARNING = '提交后您将无法编辑申请。请在继续之前仔细查看您的信息。',
  EDIT = '编辑',
  UNIT = '单元',
  SIZE = '尺寸',
  SPECIAL_INFO = '特殊信息',
  MAKE_AND_MODEL = '制造商和型号',
  EMPLOYMENT = '就业记录',
  EMPLOYMENT_HISTORY_REQUIRED = '请至少添加一条工作记录',
}
